import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, Teleport as _Teleport, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "table-row-menu__option--text" }

import SvgLoader from '@/utils/SvgLoader.vue';
import { computed, ref, StyleValue } from 'vue';
import { getRandomStr } from '@/businessRepository/idUtils';
import { i18n } from '@/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'ForecastAccuracyRowMenu',
  props: {
    disabled: { type: Boolean }
  },
  emits: ["select"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

/** Emits */
const emits = __emit;

/** Variables */
const t = i18n.t;
const containerId = getRandomStr(16);
const isMenuOpenedState = ref<boolean>(false);
const menuButtonPosition = ref({
  x: 0,
  y: 0,
});

/** Menu items */
const MENU_ITEMS = [
  {
    value: 'download' as const,
    icon: 'save_alt',
    text: 'ダウンロード',
  },
];

/** Function */
/**
 * ボタンクリック時orモーダル外をクリックした際の処理
 */
const onClickButton = () => {
  if (!isMenuOpenedState.value) {
    const buttonContent = document.getElementById(containerId);
    const bodyContent = document.getElementsByTagName('body')[0];
    if (!(buttonContent instanceof HTMLElement) || !(bodyContent instanceof HTMLElement)) return;
    menuButtonPosition.value = {
      x: buttonContent.offsetWidth,
      y: buttonContent.getBoundingClientRect().top,
    };
  }
  isMenuOpenedState.value = !isMenuOpenedState.value;
};

const dropdownMenuStyle = computed((): StyleValue => {
  return {
    top: `${menuButtonPosition.value.y + 20}px`,
    right: `${menuButtonPosition.value.x}px`,
  };
});

/**
 * 選択肢を選んだ際の処理
 * @param value - 選択した値
 */
const selectOption = (value: (typeof MENU_ITEMS)[number]['value']) => {
  isMenuOpenedState.value = false;
  emits('select', value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      id: _unref(containerId),
      class: _normalizeClass(["table-row-menu__button__container", { 'not-allow-cursor': _ctx.disabled }])
    }, [
      _createElementVNode("button", {
        class: _normalizeClass(["table-row-menu__button", { 'table-row-menu__button--active': isMenuOpenedState.value, 'disabled-event': _ctx.disabled }]),
        onClick: onClickButton
      }, [
        _createVNode(SvgLoader, {
          class: "table-row-menu__icon",
          name: "menuEllipsis"
        })
      ], 2)
    ], 10, _hoisted_1),
    (isMenuOpenedState.value)
      ? (_openBlock(), _createBlock(_Teleport, {
          key: 0,
          to: "body"
        }, [
          _createElementVNode("div", {
            class: "table-row-menu__bg",
            onClick: onClickButton
          }),
          _createElementVNode("div", {
            class: "table-row-menu__dropdown",
            style: _normalizeStyle(dropdownMenuStyle.value)
          }, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(MENU_ITEMS, (option) => {
              return _createElementVNode("div", {
                key: option.value,
                class: "table-row-menu__content"
              }, [
                _createElementVNode("button", {
                  class: "table-row-menu__option table-row-menu__option--active",
                  onClick: ($event: any) => (selectOption(option.value))
                }, [
                  _createVNode(SvgLoader, {
                    class: "table-row-menu__icon",
                    name: option.icon
                  }, null, 8, ["name"]),
                  _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)(option.text)), 1)
                ], 8, _hoisted_2)
              ])
            }), 64))
          ], 4)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})